import { useTheme, styled } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import { NextImage, RichText, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import SupportForm from '../SupportForm/SupportForm';
import { ISubPageProps } from '../Support.types';
import Breadcrumbs from '../../shared/Breadcrumbs/Breadcrumbs';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { hideBanner } from '../../../features/crBannerSlice';
import UiHeading from '../../shared/Heading';
import UiBox from '../../shared/Box';
import UiText from '../../shared/Typography/UiText';
import UiSpacer from '../../shared/Spacer/Spacer';

const AlertInfoBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  position: 'fixed',
  top: '89px',
  left: 0,
  width: '100%',
  zIndex: 5,
}));

const SupportSubpage: React.FC<ISubPageProps> = (props) => {
  const theme = useTheme();
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const title = props.fields?.title;
  const description = props.fields?.description;
  const ErrorMessage = props.fields?.emailContentInfo?.fields?.ErrorMessage;
  const isBannerShown = useSelector((state: RootState) => state.crBanner.isBannerShown);
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box
      sx={{
        marginTop: '50px',
        marginInline: '5rem',
        maxWidth: '100%',
        [theme.breakpoints.down('lg')]: {
          marginInline: '2.5rem',
        },
        [theme.breakpoints.up('xl')]: {
          width: '1300px',
          marginInline: 'auto !important',
          paddingLeft: '1rem',
        },
      }}
      id="support-subpage"
      className="ui-support-subpage"
    >
      {isBannerShown && (
        <AlertInfoBox>
          <Alert
            icon={<LockOpenIcon fontSize="inherit" />}
            variant="filled"
            severity="error"
            onClose={() => {
              dispatch(hideBanner());
            }}
            sx={{ color: '#fff !important' }}
          >
            {ErrorMessage?.value}
          </Alert>
        </AlertInfoBox>
      )}
      {props?.breadcrumbsData?.item && <Breadcrumbs {...props?.breadcrumbsData} />}
      {!isFormSubmitted ? (
        <>
          <UiBox styles={{ paddingTop: '2rem' }}>
            {title && (
              <UiHeading size="h2" color="primary" id="ui-support-subpage-title">
                {title}
              </UiHeading>
            )}
          </UiBox>
          <UiBox styles={{ marginTop: '1rem' }}>
            <UiText color="black">
              <RichText field={description} id="ui-support-subpage-subheading" />
            </UiText>
          </UiBox>
          <Box
            sx={{
              width: '50%',
              padding: '2rem 0',
              [theme.breakpoints.down('lg')]: {
                width: '100%',
              },
            }}
          >
            <SupportForm {...props} setIsFormSubmitted={setIsFormSubmitted} />
          </Box>
        </>
      ) : (
        <div style={{ padding: '3rem 0' }}>
          <NextImage
            field={props.fields?.emailContentInfo?.fields?.successIcon}
            data-testid="image-content-image"
            width={isMobile ? 86 : 101}
            height={isMobile ? 77 : 91}
          />
          <UiSpacer size="md" />
          <UiHeading size="h2" isChildren className="ui-support-subpage-title">
            <Text field={props.fields?.emailContentInfo?.fields?.successTitle}></Text>
          </UiHeading>
          <UiSpacer size="sm" />
          <UiText size="body" className="ui-support-subpage-description">
            <Text field={props.fields?.emailContentInfo?.fields?.successDescription}></Text>
          </UiText>
        </div>
      )}
    </Box>
  );
};
export default SupportSubpage;
